export default __webpack_public_path__ + "static/B0241-41dfc7bae3a5ee38df9b93405d8fc6f3.png";